import React, { useEffect, useState } from 'react';
import { useDialog } from '@context/DialogContext';
import CompanyAccountListTable from '@components/common/Table/CompanyAccountListTable';
import Pagination from '@components/common/Shared/Pagination';
import api from '@api/axios';
import { Select, MenuItem } from '@mui/material';

const CompanyAccountList = () => {
  const [companyAccountList, setCompanyAccountList] = useState([]);
  const [companyAccountListTotal, setCompanyAccountListTotal] = useState(0);
  const [checkedAccountList, setCheckedAccountList] = useState([]);
  const [page, setPage] = useState(1);
  const { showDialog } = useDialog();
  const [pageSize, setPageSize] = useState(30);
  const [name, setName] = useState('');
  const [accountType, setAccountType] = useState('법인사업자');
  const [orderBy, setOrderBy] = useState('company_name');
  const [orderDir, setOrderDir] = useState('ASC');

  // 페이지 이동
  const onDefaultSearch = (page) => {
    setCheckedAccountList([]);
    setPage(page);

    let url = `/api/account/readAccountList?`;
    url += page ? `&page=${page}` : '';
    url += pageSize ? `&pageSize=${pageSize}` : '';
    url += accountType ? `&accountType=${accountType}` : '';
    url += name ? `&name=${name}` : '';
    url += orderBy ? `&orderBy=${orderBy}` : '';
    url += orderDir ? `&orderDir=${orderDir}` : '';

    api
      .get(url)
      .then((res) => {
        console.log('res');
        console.log(res);
        const list = res.data.result.rows;
        const total = res.data.result.total === 0 ? 1 : res.data.result.total;        

        setCompanyAccountList(list);
        setCompanyAccountListTotal(total);
        
      });
  };

  useEffect(() => {    
    onDefaultSearch(page);    
  }, [page, orderBy, orderDir]);

  useEffect(() => {
    onSearch();  
    setPage(1);
  }, [pageSize]);

  // 검색
  const onSearch = () => {
    setCheckedAccountList([]); 

    let url = `/api/account/readAccountList?`;
    url += pageSize ? `&pageSize=${pageSize}` : '';
    url += accountType ? `&accountType=${accountType}` : '';
    url += name ? `&name=${name}` : '';

    api
      .get(url)
      .then((res) => {
        console.log('res');
        console.log(res);
        const list = res.data.result.rows;
        const total = res.data.result.total === 0 ? 1 : res.data.result.total;
        setCompanyAccountList(list);
        setCompanyAccountListTotal(total);
        setPage(1);
        setOrderBy('company_name');
        setOrderDir('ASC');
      });
  };

  // 체크박스 선택 및 미선택(개별 선택)
  const handleCheckboxChange = (e, companyId) => {
    if (e.target.checked) {
      setCheckedAccountList([...checkedAccountList, companyId]);        
    } else {
      setCheckedAccountList(checkedAccountList.filter((id) => id !== companyId));
    }
  };

  // 체크박스 선택 및 미선택시(전체 선택)
  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedAccountList(companyAccountList.map((item) => item.id));
    } else {
      setCheckedAccountList([]); 
    }
  };

  // 체크한 법인사업자 리스트 삭제
  const onDeleteAccount = () => {
    if (checkedAccountList.length === 0) {
      showDialog({
        type: 'alert',
        title: '확인',
        message: '삭제할 법인사업자 정보를 선택해 주세요.',
      });
    }
    else {
      showDialog({
        type: 'confirm',
        title: '삭제',
        message: '정말 삭제하시겠습니까?',
        onConfirm: () => {
            api
        .post('/api/account/deleteAccount', {
          accountList: checkedAccountList,
          accountType: accountType
        })
        .then((res) => {
          console.log('onDeleteAccount :: res');
          console.log(res);
        if (res.status === 200) {
          showDialog({ title: '법인사업자 리스트 삭제', message: '삭제되었습니다.', modalType: 'alert' });
          onSearch();
        }
      })
      .catch((err) => {
        console.log('onDeleteAccount :: err');
        console.log(err);
      });
        },
      });
    }
  };

  const isCheckboxAllSelect = companyAccountList.length > 0 && companyAccountList.length === checkedAccountList.length;

  return (
    <React.Fragment>
      <CompanyAccountListTable
        companyAccountList={companyAccountList}
        companyAccountListTotal={companyAccountListTotal}
        checkedAccountList={checkedAccountList}        
        setName={setName}
        onSearch={onSearch}
        onDefaultSearch={onDefaultSearch}
        onDeleteAccount={onDeleteAccount}
        handleCheckboxChange={handleCheckboxChange}
        handleCheckAll={handleCheckAll}
        isCheckboxAllSelect={isCheckboxAllSelect}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        orderDir={orderDir}
        setOrderDir={setOrderDir}
      />
    </React.Fragment>
  );
};

export default CompanyAccountList;
